import styled, { css } from 'styled-components'
import { colors } from 'client/styles'
import { TagBase } from '../Tag/styles'
import { DiscountTagBase } from '../DiscountTag/styles'
import { AdditionalFeesBase } from 'src/comps/AdditionalFees/styles'
import { CheckoutWalletSelectorBase } from 'src/comps/CheckoutWalletSelector/styles'

type Variant = 'subtract' | 'bold' | 'rate' | 'nopadding' | 'total' | 'pay'

function getLineVariant(variant?: Variant) {
  if (variant === 'subtract') {
    return css`
      align-items: center;
      font-weight: 700;
      color: ${colors.magenta};
    `
  }

  if (variant === 'bold') {
    return css`
      font-weight: 700;
    `
  }

  if (variant === 'rate') {
    return css`
      border-block-start: 1px solid ${colors.grey4};
      color: ${colors.grey1};
      font-weight: 700;
      padding-block-start: 16px;
      padding-block-end: 0;

      &:not(:last-child) {
        margin-block-end: 12px;
      }
    `
  }

  if (variant === 'nopadding') {
    return css`
      padding-block-end: 0;
    `
  }

  if (variant === 'total') {
    return css`
      border-block-start: 1px solid ${colors.grey4};
      color: ${colors.grey1};
      padding-block-start: 16px;
      font-weight: 700;
      &:last-child {
        padding-block-end: 0;
      }
    `
  }

  if (variant === 'pay') {
    return css`
      padding-block-end: 8px;
    `
  }

  return css`
    color: ${colors.grey2};
    &:last-child {
      padding-block-end: 0;
    }
  `
}

export const PriceDetailsBase = styled.section`
  background-color: ${colors.white};
  color: ${colors.grey2};

  ${TagBase} {
    margin-inline-start: -20px;
    padding-inline-start: 20px;
    border-start-end-radius: 0;
    border-end-end-radius: 8px;
    border-end-start-radius: 8px;
    border-start-start-radius: 0;
  }

  ${DiscountTagBase} {
    margin-inline-start: -20px;
    padding-inline-start: 20px;
    width: auto;
  }

  ${AdditionalFeesBase} {
    margin-block: 8px 16px;
    margin-inline: 0;
  }

  ${CheckoutWalletSelectorBase} {
    margin-block-end: 16px;
  }
`

export const Amount = styled.span<{ prime?: boolean; promoColor?: boolean }>`
  display: block;
  text-align: end;
  ${props => props.promoColor && `color: ${colors.black}`}
  ${props => props.prime && `color: ${colors.purple2}`}
`

export const Line = styled.div<{ variant?: Variant }>`
  display: flex;
  font-size: 16px;
  justify-content: space-between;
  line-height: 1.4;
  padding-block-end: 16px;
  ${({ variant }) => getLineVariant(variant)}

  p {
    flex: 1 1 auto;
  }

  ${Amount} {
    flex: 0 0 auto;
  }
`

export const LineAdditionalFeesBase = styled(Line)``

export const Title = styled(Line)`
  color: ${colors.grey1};
  font-size: 21px;
  font-weight: 700;
  padding-block: 0 20px;
  padding-inline: 0;
`

export const LineRoomResume = styled.div`
  white-space: break-spaces;
  text-transform: lowercase;

  span {
    text-transform: none;
    font-size: 14px;
    line-height: 1.4em;
  }
`

export const Room = styled.p<{ isCancelled: boolean }>`
  ${props => props.isCancelled && ` text-decoration: line-through`};
`

export const TaxesWrapper = styled.span`
  display: flex;
  line-height: 1.3;
  svg {
    cursor: pointer;
    margin-inline-start: 10px;
  }
`

export const TaxesModalWrapper = styled.div``

export const DiscountText = styled.div<{ prime: boolean }>`
  font-size: 14px;
  line-height: 1.4em;

  span {
    font-weight: 700;
    color: ${props => (props.prime ? props.theme.colors.prime2 : props.theme.colors.brand1)};
  }
`

export const PromoText = styled.b<{ color: string }>`
  font-weight: 700;
  color: ${props => props.color ?? props.theme.colors.brand1};
`

export const Note = styled.span`
  color: ${props => props.theme.colors.grey3};
  font-size: 14px;
`
